export const DAY_VIEW_PRIORITY_TASK_HEIGHT = 'DAY_VIEW_PRIORITY_TASK_HEIGHT';
